module.exports = "/images/sn.svg?8651bc06943be0622a02ffae7b40aab6";